// 默认的浏览器节点为当前服务器的 /api
export const DEFAULT_PROVIDER = "/api";

// 本地存放 节点地址的key
export const STORAGE_PROVIDER_KEY = "Provide_API";

// 本地存放 节点execer的key
export const STORAGE_EXECER_KEY = "Provide_EXECER";

// 执行器
export const DEFAULT_EXECER = "token";

// 存放在session中的key
// maxHeight
export const SESSION_MAXHEIGHT_KEY = "maxHeight";
// maxHash
export const SESSION_MAXHASH_KEY = "maxHash";
